<template lang="pug">
.zoom-controls
  button.zoom-controls__button(
    :disabled='currentScale <= minZoom'
    @click='zoomOut'
    v-tooltip:bottom='`Diminuir zoom`'
  )
    icon(name='magnifying-glass-minus')
  span.zoom-controls__text {{ (currentScale * 100).toFixed(0) }}%
  button.zoom-controls__button(
    :disabled='currentScale >= maxZoom'
    @click='zoomIn'
    v-tooltip:bottom='`Aumentar zoom`'
  )
    icon(name='magnifying-glass-plus')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'PdfZoomControls',
  components: {
    Icon,
  },
  props: {
    currentScale: {
      type: Number,
      required: true,
    },
    minZoom: {
      type: Number,
      default: 0.6,
    },
    maxZoom: {
      type: Number,
      default: 1.0,
    },
  },
  methods: {
    zoomIn() {
      const newScale = Math.min(this.currentScale + 0.1, this.maxZoom);
      this.$emit('update:currentScale', newScale);
    },
    zoomOut() {
      const newScale = Math.max(this.currentScale - 0.1, this.minZoom);
      this.$emit('update:currentScale', newScale);
    },
  },
};
</script>

<style lang="stylus">
.zoom-controls
  display: flex
  align-items: center
  gap: 8px
  background: rgba(255, 255, 255, 0.9)
  backdrop-filter: blur(10px)
  padding: 8px
  border-radius: 24px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1)

  &__text
    font-size: 0.9rem
    font-weight: 500
    color: #013D52
    min-width: 40px
    text-align: center

  &__button
    background: none
    border: none
    padding: 8px
    cursor: pointer
    color: #013D52
    transition: all 0.2s ease
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    width: 40px
    height: 40px

    &:hover:not(:disabled)
      background: rgba(1, 61, 82, 0.1)

    &:disabled
      opacity: 0.5
      cursor: not-allowed

    .icon
      font-size: 1.2rem

@media (max-width: 576px)
  .zoom-controls
    padding: 6px
    gap: 6px

    &__text
      font-size: 0.8rem
      min-width: 36px

    &__button
      width: 36px
      height: 36px
      padding: 6px

      .icon
        font-size: 1rem

@media (max-width: 375px)
  .zoom-controls
    padding: 4px
    gap: 4px

    &__text
      font-size: 0.75rem
      min-width: 32px

    &__button
      width: 32px
      height: 32px
      padding: 4px

      .icon
        font-size: 0.9rem
</style>
